import React from 'react'
import { Modal } from '../../../components/Modal/Modal'
import { Col, Container, Row } from 'react-bootstrap'
import { useDeleteScorecardMutation } from '../../../store/ai/scorecard'
import { useAppSelector } from '../../../store/hooks'
import { selectAccountId } from '../../../store/auth/authSlice'
import { Scorecard } from '../../../models/Scorecard'

export interface DeleteFormModalProps {
  show: boolean
  onHide: () => void
  form: Scorecard | null
}

export const DeleteFormModal: React.FC<DeleteFormModalProps> = ({ show, onHide, form }) => {
  const accountId = useAppSelector(selectAccountId)
  const [deleteScorecard, { isLoading }] = useDeleteScorecardMutation()

  const handleDeleteForm = async () => {
    if (form) {
      await deleteScorecard({
        accountId: accountId,
        scorecardId: form.id,
      })
      onHide()
    }
  }

  const modalBody = (
    <Container>
      <Row className='pb-3'>
        <Col>
          <h4 className='d-flex justify-content-center align-items-center'>Delete Form</h4>
        </Col>
      </Row>
      <Row className='pb-2 d-flex justify-content-center align-items-center text-center'>
        <Col className='p-0'>
          <div className='paragraph-medium'>Do you want to delete the following form: {form?.name} ?</div>
        </Col>
      </Row>
    </Container>
  )

  return (
    <Modal
      show={show}
      onHide={onHide}
      header={<></>}
      body={modalBody}
      showFooterActions
      footerPrimaryActionTitle='Delete'
      footerPrimaryActionButtonVariant='primary'
      footerPrimaryActionLoading={isLoading}
      onFooterPrimaryAction={handleDeleteForm}
    />
  )
}
